import React, { useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import CommonDialogDataGrid from "../components/CommonDialogDataGrid";

const UpdateRuleSetMapDialog = ({
  open,
  onClose,
  onSave,
  allRuleSets,
  mappedRuleSetKeys,
}) => {
  // 1) Initialize once from props (no syncing effect)
  const [selectedKeys, setSelectedKeys] = useState(
    () => mappedRuleSetKeys || []
  );

  // 2) Derive diffs + "hasChanges" without setState
  const { added, removed, hasChanges } = useMemo(() => {
    const addedLocal = selectedKeys.filter(
      (k) => !mappedRuleSetKeys.includes(k)
    );
    const removedLocal = mappedRuleSetKeys.filter(
      (k) => !selectedKeys.includes(k)
    );
    return {
      added: addedLocal,
      removed: removedLocal,
      hasChanges: addedLocal.length > 0 || removedLocal.length > 0,
    };
  }, [selectedKeys, mappedRuleSetKeys]);

  const handleSave = () => {
    onSave(added, removed);
  };

  const sortedInitialRows = useMemo(() => {
    return [...allRuleSets]
      .sort((a, b) => {
        const aSelected = mappedRuleSetKeys.includes(a.ruleConfigRuleSetKey);
        const bSelected = mappedRuleSetKeys.includes(b.ruleConfigRuleSetKey);
        return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
      })
      .map((rs) => ({
        id: rs.ruleConfigRuleSetKey,
        ruleConfigRuleSetName: rs.ruleConfigRuleSetName,
        priority: rs.priority,
        ruleCount: rs.ruleCount,
      }));
  }, [allRuleSets, mappedRuleSetKeys]);

  const columns = [
    { field: "ruleConfigRuleSetName", headerName: "Rule Set Name", flex: 2 },
    { field: "priority", headerName: "Priority", flex: 1 },
    { field: "ruleCount", headerName: "# of Rules", flex: 1 },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      // 3) Optional: remount when the source selection changes to reset local state
      // key={mappedRuleSetKeys.join(",")}
    >
      <DialogTitle>Update RuleSet Mapping</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            height: "calc(100vh - 300px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CommonDialogDataGrid
            // If you prefer to remount only the grid instead of the whole dialog:
            // key={mappedRuleSetKeys.join(",")}
            rows={sortedInitialRows}
            columns={columns}
            checkboxSelection
            selectionModel={selectedKeys}
            onSelectionChange={(newSelection) => setSelectedKeys(newSelection)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!hasChanges}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRuleSetMapDialog;
